export default {"src":"/login-app/[GIT_HASH]/_next/static/media/panel_show_left.7c7f7114.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};